import { CountryGroupDTO } from 'src/app/core/models/system/country-group/country-group.dto';
import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { forkJoin, Observable, of, switchMap } from 'rxjs';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class CountryGroupService {

  constructor(
    private encryptionService: EncryptionService, 
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public deleteCountryAllocation(allocationId: number): Observable<boolean> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>allocationId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;

                            return this.httpClientService.delete(environment.eSimApi +
                                                                  eSimApiPaths.CountryGroups + "/" +
                                                                  eSimApiPaths.CountryGroupsDeleteCountryAllocation +
                                                                  "?idEncSS=" + idEncSS, undefined);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public deleteCountryGroup(groupId: number): Observable<boolean> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>groupId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;

                            return this.httpClientService.delete(environment.eSimApi +
                                                                  eSimApiPaths.CountryGroups + "/" +
                                                                  eSimApiPaths.CountryGroupsDeleteCountryGroup +
                                                                  "?idEncSS=" + idEncSS, undefined);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getById(groupId: number): Observable<CountryGroupDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>groupId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;

                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.CountryGroups + "/" +
                                                                  eSimApiPaths.CountryGroupsGetCountryGroupById +
                                                                  "?idEncSS=" + idEncSS, undefined);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getAllCountriesForGroupId(groupId: number): Observable<any> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>groupId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const idEncSS=encResult.result;

                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.CountryGroups + "/" +
                                                                  eSimApiPaths.CountryGroupsGetAllCountriesForGroupId +
                                                                  "?idEncSS=" + idEncSS, undefined);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getCountryGroupsForCompanyByCompanyId(companyId: number): Observable<CountryGroupDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const companyIdEncSS=encResult.result;

                            return this.httpClientService.getById(environment.eSimApi +
                                                                  eSimApiPaths.CountryGroups + "/" +
                                                                  eSimApiPaths.CountryGroupsGetCountryGroupsForCompany +
                                                                  "?companyIdEncSS=" + companyIdEncSS, undefined);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public post(countryGroup: CountryGroupDTO): Observable<CountryGroupDTO> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(countryGroup), false)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const objectEncSS=encResult.result;

                            return this.httpClientService.post(environment.eSimApi +
                                                               eSimApiPaths.CountryGroups + '/' +
                                                               eSimApiPaths.CountryGroupsPost,
                                                               {objectEncSS:objectEncSS}, undefined);
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public put(countryGroup: CountryGroupDTO): Observable<CountryGroupDTO> {
    try {
      return forkJoin({
               idEncResult       : this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>countryGroup.id),
               objectEncResultSS : this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(countryGroup),false)
             })
             .pipe(
               switchMap(({ idEncResult, objectEncResultSS }) => {
                 const idEnc      =idEncResult.result;
                 const objectEncSS=objectEncResultSS.result;

                 return this.httpClientService.put(environment.eSimApi +
                                                   eSimApiPaths.CountryGroups + '/' +
                                                   eSimApiPaths.CountryGroupsPut,
                                                   undefined,
                                                   {idEnc:idEnc, objectEncSS:objectEncSS}, undefined);
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public save(countryGroup: CountryGroupDTO): Observable<any> {
    try {
      if (countryGroup.id && (<number>countryGroup.id>0 || countryGroup.groupName == "¬¬!!PUT!!¬¬"))
        return this.put(countryGroup);

      return this.post(countryGroup);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

}
